import React, {useRef} from "react";
import {css, Theme} from "@emotion/react";

import {Apla} from "@pg-design/apla-module";
import {elevation} from "@pg-design/elevation";
import {Container} from "@pg-design/grid-module";
import {borderRadius, flex, mt, p, pb, pointer, pt, pv, w100, zIndex} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {rankingLastYear} from "../constants/ranking";
import {rankingSelectionTracking} from "../tracking/ranking_selection_tracking";
import {getRankingCitiesIdByYear} from "../utils/get_ranking_cities_ids";

export const RankingCitiesTiles = () => {
    const cities = getRankingCitiesIdByYear();
    const {data: citiesList} = useGetRegionDetailListQuery({regionIds: cities});

    const tilesRef = useRef(null);

    return (
        <section css={rankingCitiesTilesWrapper}>
            <Container css={content}>
                <Text align="center" as="h2" variant="headline_3">
                    Wyniki roczne dla wybranych miast
                </Text>

                {citiesList && (
                    <div css={tilesList} ref={tilesRef}>
                        {citiesList.map((city) => {
                            const cityImageSrc = require(`../images/cities/${city.slug}.png`);

                            const url = rpAppLink.ranking.lastYearList({
                                citySlug: city.slug
                            });

                            const onTileClick = () => {
                                rankingSelectionTracking({city: city.name, year: rankingLastYear.toString()});
                            };

                            return (
                                <Apla<{href: HTMLAnchorElement["href"]}>
                                    applyOn={<img css={[w100, borderRadius(2)]} src={cityImageSrc} alt={city.name} />}
                                    as="a"
                                    href={url}
                                    key={city.id}
                                    css={cityHolder}
                                    onClick={onTileClick}
                                >
                                    <Text align="center" as="span" color="#fff" css={cityName} variant="headline_3">
                                        {city.name}
                                    </Text>
                                </Apla>
                            );
                        })}
                    </div>
                )}
            </Container>
        </section>
    );
};

const rankingCitiesTilesWrapper = (theme: Theme) => css`
    background-color: ${theme.colors.info};
    ${pt(3)};
    ${pb(5)};
    position: relative;

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(4)};
    }
`;

const content = (theme: Theme) => css`
    @media (max-width: ${theme.breakpoints.md}) {
        position: relative;
        max-width: 100%;
        ${p(0)};
    }
`;

const tilesList = (theme: Theme) => css`
    display: flex;
    overflow: scroll;
    flex-wrap: nowrap;
    ${mt(3)};
    column-gap: 2.4rem;

    @media (min-width: ${theme.breakpoints.md}) {
        overflow: hidden;
        gap: 2.4rem;
        flex-wrap: wrap;
        justify-content: center;
    }
`;

const cityHolder = (theme: Theme) => css`
    ${pointer};
    ${flex()};
    min-width: 26.4rem;
    width: 26.4rem;
    height: 22.8rem;
    position: relative;
    ${elevation(2)};
    transition: box-shadow 0.4s;

    &:hover {
        transition: box-shadow 0.4s;
        ${elevation(4)};
    }

    &::after {
        ${borderRadius(2)};
    }

    @media (max-width: ${theme.breakpoints.md}) {
        &:first-of-type {
            margin-left: 1.2rem;
        }

        &:last-of-type {
            margin-right: 1.2rem;
        }
    }
`;

const cityName = css`
    ${borderRadius(2)};
    ${w100};
    ${zIndex(2)};
    position: absolute;
    bottom: 1.6rem;
`;
import React, {useRef} from "react";
import {css, Theme} from "@emotion/react";

import {Apla} from "@pg-design/apla-module";
import {elevation} from "@pg-design/elevation";
import {Container} from "@pg-design/grid-module";
import {borderRadius, flex, mt, p, pb, pointer, pt, pv, w100, zIndex} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {rankingLastYear} from "../constants/ranking";
import {rankingSelectionTracking} from "../tracking/ranking_selection_tracking";
import {getRankingCitiesIdByYear} from "../utils/get_ranking_cities_ids";

export const RankingCitiesTiles = () => {
    const cities = getRankingCitiesIdByYear();
    const {data: citiesList} = useGetRegionDetailListQuery({regionIds: cities});

    const tilesRef = useRef(null);

    return (
        <section css={rankingCitiesTilesWrapper}>
            <Container css={content}>
                <Text align="center" as="h2" variant="headline_3">
                    Wyniki roczne dla wybranych miast
                </Text>

                {citiesList && (
                    <div css={tilesList} ref={tilesRef}>
                        {citiesList.map((city) => {
                            const cityImageSrc = require(`../images/cities/${city.slug}.png`);

                            const url = rpAppLink.ranking.lastYearList({
                                citySlug: city.slug
                            });

                            const onTileClick = () => {
                                rankingSelectionTracking({city: city.name, year: rankingLastYear.toString()});
                            };

                            return (
                                <Apla<{href: HTMLAnchorElement["href"]}>
                                    applyOn={<img css={[w100, borderRadius(2)]} src={cityImageSrc} alt={city.name} />}
                                    as="a"
                                    href={url}
                                    key={city.id}
                                    css={cityHolder}
                                    onClick={onTileClick}
                                >
                                    <Text align="center" as="span" color="#fff" css={cityName} variant="headline_3">
                                        {city.name}
                                    </Text>
                                </Apla>
                            );
                        })}
                    </div>
                )}
            </Container>
        </section>
    );
};

const rankingCitiesTilesWrapper = (theme: Theme) => css`
    background-color: ${theme.colors.info};
    ${pt(3)};
    ${pb(5)};
    position: relative;

    @media (min-width: ${theme.breakpoints.md}) {
        ${pv(4)};
    }
`;

const content = (theme: Theme) => css`
    @media (max-width: ${theme.breakpoints.md}) {
        position: relative;
        max-width: 100%;
        ${p(0)};
    }
`;

const tilesList = (theme: Theme) => css`
    display: flex;
    overflow: scroll;
    flex-wrap: nowrap;
    ${mt(3)};
    column-gap: 2.4rem;

    @media (min-width: ${theme.breakpoints.md}) {
        overflow: hidden;
        gap: 2.4rem;
        flex-wrap: wrap;
        justify-content: center;
    }
`;

const cityHolder = (theme: Theme) => css`
    ${pointer};
    ${flex()};
    min-width: 26.4rem;
    width: 26.4rem;
    height: 22.8rem;
    position: relative;
    ${elevation(2)};
    transition: box-shadow 0.4s;

    &:hover {
        transition: box-shadow 0.4s;
        ${elevation(4)};
    }

    &::after {
        ${borderRadius(2)};
    }

    @media (max-width: ${theme.breakpoints.md}) {
        &:first-of-type {
            margin-left: 1.2rem;
        }

        &:last-of-type {
            margin-right: 1.2rem;
        }
    }
`;

const cityName = css`
    ${borderRadius(2)};
    ${w100};
    ${zIndex(2)};
    position: absolute;
    bottom: 1.6rem;
`;
